var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{class:_vm.selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'},[_vm._v("\n        Réparation en autonomie\n    ")]),_vm._v(" "),_c('div',{staticClass:"border rounded-lg p-4 mt-2"},[_c('iframe',{staticClass:"w-full h-[450px]",attrs:{"id":"tchat-iframe","src":_vm.tchatUrl}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff2ebfd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/processes/cards/tchat/NewOwnTchatCard.vue
// module id = null
// module chunks = 